import { Link, Outlet,NavLink, useLoaderData } from "react-router-dom"
import { formatDate, getUserId } from "../services/helpers";
import { useEffect, useState } from "react";
import { Form } from "react-router-dom";
import { Select } from "../components/Select";
import { Button } from "../components/Button";
import { TextArea, TextField } from "../components/TextField";
import { addCustomerNote, addMembershipPayment } from "../services/api";
import "../styles/memberDetailsDialog.css";
import mixpanel from "../services/mixpanel";

export function MemberDetails(){
	const loaderData = useLoaderData();
	const details = loaderData.details;
	const _plans = loaderData.plans.packages;
	const _methods = loaderData.payment_methods.data;
	const [visibleSection,setVisibleSection] = useState("vehicles");
	const [visibleDialog, setVisibleDialog] = useState(null);
	const [selectedPlan,setSelectedPlan] = useState(_plans[0].plan_name);
	const [selectedOption,setSelectedOption] = useState(_plans[0].duration);
	const [selectedSubscription,setSetSelectedSubscription] = useState(_plans[0].option_id);
	const [dateSubscribed,setDateSubscribed] = useState((new Date()).toISOString().substring(0,10));
	const [paymentMethod, setPaymentMethod] = useState(_methods[0].method_name);


	useEffect(changeSelectedPlan,[selectedOption,selectedPlan])
	useEffect(()=>{
		mixpanel.identify(getUserId());
	},[]);

	const handleCloseDialog = () => {
		setVisibleDialog(null);

	};

	function addNote(){
		const form = document.getElementById("addCustomerNote");
		const formData = new FormData(form);

		const payload = {
			"tag" : formData.get("tag"),
			"customer_id" : details.customer_details.uuid,
			"comment" : formData.get("comment")
		}

		if (formData.get('comment') === ""){
			alert("You need to add details to the note");
			return;
		}

		addCustomerNote(payload).then(async(response)=>{
			const result = await response.json();
			if (result["note_id"]){
				handleCloseDialog();
				alert("Added customer note");
			}

		});


	}

	async function addMembership(){
		const user_id = details.customer_details.customer_id;
		const response = await addMembershipPayment(
			{
				"user_id" : user_id,
				"date_subscribed" : dateSubscribed,
				"plan_id" : selectedSubscription,
				"payment_method" :_methods.find(method=>method.method_name === paymentMethod).method_id
			}
		);
		const result = await response.json()

		if(result.msg){

			handleCloseDialog();
		}


	}

	function calcSubscriptionExpiry(){
		if(dateSubscribed){
			let oneMonthmilisecs= 2678400000;

			switch(selectedOption){
				case "quarterly":
					return new Date(new Date(dateSubscribed).getTime()+ 3* oneMonthmilisecs).toISOString().substring(0,10)
				case "biannually":
					return new Date(new Date(dateSubscribed).getTime()+ 6* oneMonthmilisecs).toISOString().substring(0,10)
				case "annually":
					return new Date(new Date(dateSubscribed).getTime()+ 12* (oneMonthmilisecs)-(7*1000*60*60*24)).toISOString().substring(0,10)
				default:
					return dateSubscribed;

			}
		}

	}

	function changeSelectedPlan(){
		const plan_name = selectedPlan;
		const plan_duration = selectedOption;
		setSetSelectedSubscription(_plans.find(plan=>
			plan.plan_name === plan_name
			&& plan.duration=== plan_duration
			).option_id
		);
	}


	function renderActions(page){
		switch(page){
			case "":
			case "vehicles":
				return <Link to="add_customer_vehicle">Add New Vehicle</Link>;
			case "subscriptions":
				return <p><Link onClick={()=> setVisibleDialog("membership")}>Add Membership Subscription</Link></p>;
			case "service history":
				return <Link to={`/dashboard/services/add_ticket`} state={{customer_id: details.customer_details.customer_id}}>Create Order Ticket</Link>;
				// return <Link to={`/dashboard/members/u/${details.customer_details.uuid}/add_order`}>Create Order Ticket</Link>;
				case "notes":
				return <p><Link onClick={()=> setVisibleDialog("notes")}>Add A Note</Link></p>;
			default:
				return <></>
		}
	}




	return (
		<main id="MemberDetails">
		<h1>Customer Details</h1>
		<Link to="/dashboard/customers">Back to All customers</Link>
		<div id="page-detail-card">
			<div id="header-section">
				{/* <div id="header-image">
					<img src="https://avatar.iran.liara.run/public/43" alt="" />
				</div> */}
				<div id="start">
					{/* <div id="membership-status">
						<p>{details.customer_details.member_id}</p>
					</div> */}
					{/* <div className="row">
						<i className="location-icon">l</i>
					</div> */}
					<h3>{details.customer_details.first_name} {details.customer_details.other_names} {details.customer_details.last_name}</h3>
					<p>{details.customer_details.email}</p>
					<p>{details.customer_details.phone_number}</p>
				</div>
				<div id="middle">
					<div className="detail-actions mt-1">
						<p>Customer Since: <span>{formatDate(details.customer_details.date_created)}</span></p>
						{/* <p>Membership expiry: <span>{formatDate(details.customer_details.date_created)}</span></p> */}
						<p>Location: {details.customer_details.location}</p>
						{renderActions(visibleSection)}


					</div>
				</div>
			</div>
			<div id="action-row">
				{/* <NavLink end className={({ isActive }) => isActive ? "active-subnav" : ""} to="" onClick={()=> setVisibleSection(null)}>Details</NavLink> */}
				<NavLink className={({ isActive }) => isActive ? "active-subnav" : ""} to="vehicles" onClick={()=> setVisibleSection("vehicles")}>Vehicles</NavLink>
				<NavLink className={({ isActive }) => isActive ? "active-subnav" : ""} to="subscriptions" onClick={()=> setVisibleSection("subscriptions")}>Membership History</NavLink>
				<NavLink className={({ isActive }) => isActive ? "active-subnav" : ""} to="services" onClick={()=> setVisibleSection("service history")}>Service History</NavLink>
				<NavLink className={({ isActive }) => isActive ? "active-subnav" : ""} to="notes" onClick={()=> setVisibleSection("notes")}>Notes</NavLink>
			</div>
			<div id="body-section">
				<Outlet context={loaderData}/>
			</div>

		</div>

		{
			visibleDialog === "membership" && (
				<div className="dialog" id="membership-dialog">
					<Form>
						<style>
						</style>
						<div className="dialog-header">
							<h3>Add Subscription</h3>
						</div>
						<div className="dialog-content">
							<div className="row">
								<div className="col-6">
									<Select
										id="subscription_plan"
										label="Plan"
										options={Array.from(new Set(_plans.map(plan=>plan.plan_name)))}
										name="plan"
										onChange={(selected)=>{
											setSelectedPlan(selected.target.value);
										}}
									/>
								</div>
								<div className="col-6">
									<Select
										id="subscription_duration"
										label="Duration"
										options={_plans.filter(plan=>plan.plan_name === selectedPlan).map(entry=>entry.duration)}
										name="duration"
										onChange={(event)=>setSelectedOption(event.target.value)}
									/>
								</div>
							</div>
							<div className="row">
								<div className="col-6">
									<Select
										label="Payment Method"
										options={_methods.map(method=>method.method_name)}
										name="plan"
										value={paymentMethod}
										onChange={(event)=> setPaymentMethod(event.target.value)}
									/>
								</div>
								<div className="col-6">
									<TextField
										label={"Date of Payment"}
										type={"date"}
										onChange={(event)=>setDateSubscribed(event.target.value)}
										value={dateSubscribed}
									/>
								</div>
							</div>
							<label htmlFor="" className="grey-text">Details</label>
							<div className="row">
								<div className="col-6">
									<TextField
										label={"Amount"}
										disabled={true}
										value={`${_plans.find(entry=>entry.option_id === selectedSubscription).currency} ${_plans.find(entry=>entry.option_id === selectedSubscription).price}`}
									/>
								</div>
								<div className="col-6">
									<TextField
										label={"Expiry"}
										subLabel={"(Approximated)"}
										type={"date"}
										disabled={true}
										value={calcSubscriptionExpiry()}

									/>
								</div>
							</div>



						</div>
						<div className="dialog-footer">
							<Button onClick={handleCloseDialog} color="red" label="Cancel"/>
							<Button onClick={addMembership} label="Add Subscription" color="green" type="button" />
						</div>
					</Form>
				</div>
			)
		}


			{visibleDialog === "notes" && (
				<div className="dialog-overlay">

					<div className="dialog" >
						<Form id="addCustomerNote">
							<div className="dialog-header">
								<h3>Add A Note to The Customer</h3>
							</div>
							<div className="dialog-content">
								<div className="col-6">
									<Select
										label="Type of Note"
										options={["Info","Critical","Reminder"]}
										name="tag"
										// value={urgencyField}
										// onChange={(e) => setUrgencyField(e.target.value)}
									/>
								</div>
								<TextArea
								// value={descriptionField}
									label="Note Details"
									name="comment"
									// onChange={(e) => setDescriptionField(e.target.value)}
								/>
							</div>
							<div className="dialog-footer">
								<Button onClick={handleCloseDialog} color="red" label="Cancel"/>
								<Button onClick={addNote} label="Add Note" color="green" type="button" />
							</div>
						</Form>
					</div>
				</div>
			)}

		</main>
	)
}